module.exports = __webpack_public_path__ + "img/progress-four-done.eca32423.png";